import React from 'react';

import Link from 'next/link';

import { Button } from '../button/Button';
import { LandingSection } from '../layout/LandingSection';
import { PricingCard } from '../pricing/PricingCard';
import { PricingFeature } from '../pricing/PricingFeature';

const Pricing = () => (
  <LandingSection
    yPadding="py-36"
    subtitle="Pricing"
    title="Enjoy auto-generated social image today"
  >
    <div className="mx-4 lg:mx-32 grid grid-cols-1 md:grid-cols-3 gap-y-12">
      <PricingCard
        name="FREE"
        price="$0"
        periodicity="mo"
        button={
          <Link href="/login">
            <a>
              <Button full>Get Started</Button>
            </a>
          </Link>
        }
      >
        <PricingFeature>1 Domain</PricingFeature>
        <PricingFeature>20 Pages</PricingFeature>
        <PricingFeature>100 Preview images</PricingFeature>
      </PricingCard>
      <PricingCard
        name="PRO"
        price="$19"
        periodicity="mo"
        popular
        button={
          <Link href="/login">
            <a>
              <Button full>Get Started</Button>
            </a>
          </Link>
        }
      >
        <PricingFeature>5 Domains</PricingFeature>
        <PricingFeature>50 000 Pages</PricingFeature>
        <PricingFeature>5 000 Preview images</PricingFeature>
      </PricingCard>
      <PricingCard
        name="BUSINESS"
        price="$79"
        periodicity="mo"
        button={
          <Link href="/login">
            <a>
              <Button full>Get Started</Button>
            </a>
          </Link>
        }
      >
        <PricingFeature>100 Domains</PricingFeature>
        <PricingFeature>1 000 000 Pages</PricingFeature>
        <PricingFeature>100 000 Preview images</PricingFeature>
      </PricingCard>
    </div>
  </LandingSection>
);

export { Pricing };
